const stringsComuns = require('./comum');

module.exports = {
    ...stringsComuns,
    adicionarArquivos: 'Adicionar arquivos',
    aguardandoAnalise: 'Aguardando análise',
    aguardandoRevisao: 'Aguardando revisão',
    arquivos: 'Arquivos',
    cadastroModeloLaudo: 'Cadastro de modelo de laudo',
    dataColeta: 'Data de coleta',
    dataRecebimento: 'Data de recebimento',
    emAnalise: 'Em análise',
    envioExame: 'Envio de Exame',
    hipoteseDiagnostica: 'Hipótese diagnóstica',
    historico: 'Histórico',
    historicoClinico: 'Histórico Clínico',
    laudoRegistrado: 'Laudo registrado',
    laudoPublicado: 'Laudo publicado',
    liberado: 'Liberado',
    medicamentos: 'Medicamentos',
    modeloLaudo: 'Modelos de laudo',
    subtipoExame: 'Subtipo de exame',
    tipoExame: 'Tipo de exame'
};
